import React from 'react';
import { Icon } from './Icon.js';
export const IconChevronReduceX = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M19.0711 16.2426L14.8284 12L19.0711 7.75736", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M4.92892 7.75735L9.17157 12L4.92892 16.2426", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconChevronReduceX.js.map